"use strict";


(function (W, $, D, Drupal) {
  'use strict';

  if (typeof W.sg === 'undefined') {
    W.sg = {};
  }

  var sg = W.sg;
  var $D = $(D);
  var filterDeploy = false;
  var $root = $('.paragraph--type--liste-membres');
  var oUtils = sg.utils;
  var SHOWRAPIDITY = 500;

  var listMembres = function () {
    var filterMemberByName = function filterMemberByName() {
      /*
      *Create Filter
      */
      var aFilters = [];
      var $aMembers = $root.find('.member-thumb'); // get filter from existing member item

      $aMembers.map(function (i, el) {
        var $member = $(el);
        var filter = $member.attr('data-filter');

        if (aFilters.indexOf(filter) === -1) {
          aFilters.push(filter);
        }
      });
      aFilters = aFilters.sort(); // add list filter into DOM
      // var $span = $('<span>', {
      //   "class": 'sr-only',
      //   'aria-live': 'polite',
      //   'role': 'status'
      // });

      var $ul = $('<ul>', {
        "class": 'filter-list'
      }).append(aFilters.map(function (filter) {
        return $('<li>').append($('<button>', {
          "class": 'btn-filter-member',
          'data-filter': filter,
          'aria-label': Drupal.t('Filtrer par nom de ' + filter, {}, {
            context: 'accessibilite'
          })
        }).text(filter));
      }));
      var $allMembersLink = $('<button>', {
        "class": 'all-members-btn',
        text: Drupal.t('Afficher tous les membres', {}, {
          context: 'sg_refonte'
        })
      });
      $root.find('.filters-members')
      .append($ul)
      .append($allMembersLink);

      // Add the status span
      const statusSpan = document.getElementById('filter-status')
      /**
       * Event on filter
       */
      // deploy filter on mobile
      $root.find('.toggle-filters').on('click', function (e) {
        var $btn = $(e.currentTarget);
        var target = $btn.attr('aria-controls');
        $('#' + target).slideToggle();
        filterDeploy = !filterDeploy;
        var btnLabel = filterDeploy ? Drupal.t('Cacher les filtres', {}, {
          context: 'accessibilite'
        }) : Drupal.t('Afficher les filtres', {}, {
          context: 'accessibilite'
        });
        oUtils.toggleAriaExpanded($btn);
        $btn.attr('aria-label', btnLabel);
      });

      // Event on filter button
      $('.btn-filter-member').on('click', function (e) {
        e.preventDefault();
        var $btn = $(e.currentTarget);
        var filterBtn = $btn.attr('data-filter');
        $('.btn-filter-member').removeClass('active');
        $btn.addClass('active');
        $allMembersLink.addClass('active');
        $aMembers.map(function (i, el) {
          var $el = $(el);

          if ($(el).attr('data-filter') !== filterBtn) {
            $el.hide(SHOWRAPIDITY).addClass('hidden');
          } else {
            $el.show(SHOWRAPIDITY, function () {
              if (sg.viewport.isMobile()) {
                Drupal.blazy.init.revalidate(); // reinit Lazy loading
              }
            }).removeClass('hidden');
          }
        });

        // Update the status message
        const filterBtnText = filterBtn.replace('>', 'à')
        statusSpan.textContent = `Le filtre a été appliqué pour les noms de ${filterBtnText}`;
      });

      $allMembersLink.on('click', function (e) {
        e.preventDefault();
        $('.btn-filter-member').removeClass('active');
        $allMembersLink.removeClass('active');
        $aMembers.show(SHOWRAPIDITY, function () {
          if (sg.viewport.isMobile()) {
            Drupal.blazy.init.revalidate(); // reinit Lazy loading
          }
        });

        // Update the status message
        statusSpan.textContent = 'Le filtre a été réinitialisé pour afficher tous les membres' ;
      });
    };

    var oMod = {
      filterMemberByName: filterMemberByName,
    };
    return oMod;
  }();

  $D.ready(function () {
    listMembres.filterMemberByName();
  });
})(window, window.jQuery, document, window.Drupal);
